<template>
  <v-bottom-sheet v-model="open" width="56%" inset hide-overlay style="background-color: rgb(0,0,0) !important; margin-bottom: 20px !important;">
    <v-sheet style="box-shadow: none !important; background-color: rgba(0,0,0,0) !important;">
      <v-card class="ad-card-collapsed pa-3" elevation="5" @click="openUrl">
        <v-card-title class="justify-end mt-n7 mb-n4">
          <div class="badge">AD</div>
        </v-card-title>
        <v-card-text class="d-flex justify-space-between align-center">
          <div>
            <h3 class="ad-title">{{ ad.title }}</h3>
            <p class="ad-description">{{ ad.subtitle }}</p>
          </div>
          <v-btn v-if="ad.btnText !== null" class="ad-btn mx-5 mt-n5 px-7">{{ ad.btnText }}</v-btn>
          <v-img max-height="70px" max-width="30%" position="center center" :src="ad.avatarUrl" class="mt-n2" contain/>
        </v-card-text>
      </v-card>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
export default {
  name: "LargeCardAd",
  props: {
    ad: Object,
  },
  data() {
    return {
      open: true,
    };
  },
  methods: {
    openUrl() {
      window.open(this.ad.ctaUrl);
    }
  }
}
</script>

<style scoped>

</style>
